// extracted by mini-css-extract-plugin
export default {"tabs":"ConferenceType_tabs__DBs+s","button":"ConferenceType_button__32aEf","buttonActive":"ConferenceType_buttonActive__+WLLZ"};